import * as React from 'react';

import {Radio} from 'shells/radio/radio';
import {RadioGroup} from 'shells/radio/radio-group';
import {SelectInline} from 'shells/select-inline/select-inline';

// @ts-expect-error
import {getFormModelsFromRelationships} from '../../../../entities/helpers';

type Props = {
    name: string;
    entityType: string;
    value: string;
    excludedOptions: string[];
    nullOptionText?: string;
    anyOptionText?: string;
    affirmativeOptionText?: string;
    negativeOptionText?: string;
    searchNoun?: string;
    isNot: boolean;
    relationships?: string[];
    options?: any[];
    magicValueMaps?: {
        value: string;
        text: string;
    }[];
    onChange: (data: string) => any;
    onFilterNegationChange: (value: string, isNot: boolean) => any;
    onClearValue: () => void;
};

/*
This is our new relationship form filter component. Instead of having a field
that has is/is not, and a search field, this has 4 options for any, specific,
not specific, and none. The search fields for the specific options appear when
they're selected.
*/
export class FormNewRelationship extends React.Component<Props> {
    static defaultProps = {
        allowAny: false,
    };

    render() {
        // @ts-expect-error
        const models = this.getModels().filter((model) => {
            return this.props.value === model.id || !this.props.excludedOptions.includes(model.id);
        });

        // @ts-expect-error
        const selectValue = models.find((model) => {
            const value = this.props.value;

            return model.id === value;
        });

        const searchPlaceholder = this.props.searchNoun
            ? `Search ${this.props.searchNoun}...`
            : undefined;

        const select = (
            <SelectInline
                placeholder={searchPlaceholder}
                tokenizedStyle='dark'
                autoFocus={true}
                options={models}
                value={selectValue}
                onChange={this.handleSelectChange}
                onClearValue={this.props.onClearValue}
            />
        );

        const selectedValue = this.getSelectedValue();

        return (
            <RadioGroup
                selectedValue={selectedValue}
                name={this.props.name}
                onChange={this.handleRadioButtonChange}
            >
                <Radio value='any'>{this.props.anyOptionText}</Radio>
                {this.props.magicValueMaps
                    ? this.props.magicValueMaps.map((magicValue) => {
                          return (
                              <Radio key={magicValue.value} value={magicValue.value}>
                                  {magicValue.text}
                              </Radio>
                          );
                      })
                    : null}
                <Radio value='affirmative'>{this.props.affirmativeOptionText}</Radio>
                {selectedValue === 'affirmative' ? <div>{select}</div> : null}
                <Radio value='negative'>{this.props.negativeOptionText}</Radio>
                {selectedValue === 'negative' ? <div>{select}</div> : null}
                <Radio value='null'>{this.props.nullOptionText}</Radio>
            </RadioGroup>
        );
    }

    getSelectedValue = () => {
        if (this.props.magicValueMaps !== undefined) {
            const selectedMagicValue = this.props.magicValueMaps.find(
                (magicValue) => magicValue.value === this.props.value
            );

            if (selectedMagicValue) {
                return selectedMagicValue.value;
            }
        }

        if (this.props.value === '-' && !this.props.isNot) {
            return 'null';
        }

        if (this.props.value === '-' && this.props.isNot) {
            return 'any';
        }

        if (this.props.isNot) {
            return 'negative';
        }

        return 'affirmative';
    };

    handleRadioButtonChange = (value: string) => {
        if (value === 'null') {
            this.props.onFilterNegationChange('-', true);
        } else if (value === 'any') {
            this.props.onFilterNegationChange('-', false);
        } else if (value === 'affirmative') {
            this.props.onFilterNegationChange('', true);
        } else if (value === 'negative') {
            this.props.onFilterNegationChange('', false);
        } else {
            this.props.onFilterNegationChange(value, true);
        }
    };

    getModels = () => {
        const {name, options, relationships} = this.props;

        if (options && options.length) {
            return options.map((opt) => {
                return opt && opt.id && opt.name
                    ? {
                          id: opt.id,
                          type: 'enum',
                          name: opt.name,
                      }
                    : {
                          id: opt,
                          type: 'enum',
                          name: opt,
                      };
            });
        }

        if (relationships && relationships.length) {
            return getFormModelsFromRelationships(relationships, this.props.entityType, name);
        }

        return [];
    };

    handleSelectChange = (
        value?: {
            id: string;
        } | null
    ) => {
        if (value) {
            this.props.onChange(value.id);
        } else {
            this.props.onClearValue();
        }
    };
}
